import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// 群组列表
export function getGroupList(params){
    return http.get('/group/info/selectMyJoinGroup', params)
}

// 群组详情
export function getGroupDetail(id){
    return http.get('/group/info/detail/'+id)
}

// 群组成员列表
export function getMemberList(params){
    return http.get('/group/member/list', params)
}
// 群组活动列表
export function getActivityList(params){
    return http.get('/activity/info/group/list', params)
}
// 群组活动详情
export function getActivityDetail(id){
    return http.get('/activity/info/groupInfo/'+id)
}
// 教学设计/教学反思 列表
export function getJiaoList(params){
    return http.get('/research/researchInfo/portalList', params)
}

// 群组里-教学设计/教学反思 列表
export function getGroupJiaoList(params){
    return http.get('/research/researchInfo/group/portalList', params)
}
// 教学设计/教学反思 详情
export function getJiaoDetail(id){
    return http.get('/research/researchInfo/portal/'+id)
}
// 2+2反馈列表
export function getfankuiList(id,params){
    return http.get('/group/info/findGroupComments/2/'+id,params)
}
// 笔记列表
export function getbijiList(id,params){
    return http.get('/group/info/findGroupComments/1/'+id,params)
}
// 申请加入工作室
export function addStudio(data){
    return http.post('/group/apply', data)
}

// 申请加入工作室审核列表
export function addStudioShen(params){
    return http.get('/group/apply/list', params)
}
// 申请加入工作室审核详情
export function addStudioShenDetail(id){
    return http.get('/group/apply/'+id)
}
export function addStudioShenNum(id){
    return http.get('/group/apply/getGroupApplyNum/'+id)
}
// 申请加入工作室审核通过/驳回
export function addStudioShenAgree(status, applyIds, params){
    return http.get('/group/apply/applyHandel/'+status+'/'+applyIds, params)
}
// 共同体学校
export function bookslist(params){
    return http.get('/books/info/list',params)
}
// 共同体学校详情
export function getschooldetail(id){
    return http.get('/books/info/'+id)
}
// 教联体活动列表
export function unionBookslist(params){
    return http.get('/books/unionInfo/list',params)
}
// 教联体活动详情
export function getUnionSchooldetail(id){
    return http.get('/books/unionInfo/'+id)
}


// WEBPACK FOOTER //
// ./src/api/study/studyGroup.js